const queryFields = [
  "sortBy",
  "sortOrder",
  "page",
  "limit",
  "search",
  "createdBy",
  "path",
  "status",
  "source",
  "issueId",
];

export default queryFields;
